/* ===========================================================
   PDP DeAlba · Lógica dinámica de variantes + Sticky Cart
   =========================================================== */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', initPDP);

  // Si ya cargó el DOM, ejecutar de inmediato
  if (document.readyState !== 'loading') {
    initPDP();
  }

  function initPDP() {
    const section = document.querySelector('.pdp-galeria-compra');
    if (!section) return;

    // Leer datos del producto
    const productJsonEl = section.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    let productData;
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      console.error('PDP: Error parsing product JSON', e);
      return;
    }

    // Estado actual de selección
    const state = {
      options: [],
      variant: null,
      isSubmitting: false
    };

    // Inicializar opciones con la selección por defecto.
    // state.options es 1-indexed para alinear con option.position de Shopify
    // (state.options[1] = option1, state.options[2] = option2, etc.)
    const initialVariantId = parseInt(section.querySelector('[data-variant-id-input]').value);
    state.variant = productData.variants.find(v => v.id === initialVariantId) || productData.variants[0];

    productData.options.forEach((option, idx) => {
      const position = idx + 1;
      state.options[position] = state.variant[`option${position}`];
    });

    // ============== GALERÍA · Cambio de imagen al hacer click en thumb ==============
    const thumbs = section.querySelectorAll('.pdp-gc__thumb');
    const slides = section.querySelectorAll('.pdp-gc__main-slide');
    const counter = section.querySelector('[data-current-slide]');

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const idx = parseInt(thumb.dataset.thumbIndex);
        showSlide(idx);
      });
    });

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
      });
      if (counter) {
        counter.textContent = String(index + 1).padStart(2, '0');
      }
    }

    // ============== VARIANTES ==============
    // Color chips
    const colorChips = section.querySelectorAll('.pdp-gc__color-chip');
    colorChips.forEach(chip => {
      chip.addEventListener('click', () => {
        const value = chip.dataset.optionValue;
        const position = parseInt(chip.dataset.optionPosition);
        selectOption(position, value);

        // Actualizar UI de chips
        colorChips.forEach(c => c.classList.remove('is-active'));
        chip.classList.add('is-active');
      });
    });

    // Size buttons
    const sizeBtns = section.querySelectorAll('.pdp-gc__size-btn');
    sizeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-disabled')) return;
        const value = btn.dataset.optionValue;
        const position = parseInt(btn.dataset.optionPosition);
        selectOption(position, value);

        // Actualizar UI de botones
        sizeBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });

    // Selects (otras opciones)
    const selects = section.querySelectorAll('.pdp-gc__select');
    selects.forEach(select => {
      select.addEventListener('change', () => {
        const value = select.value;
        const position = parseInt(select.dataset.optionPosition);
        selectOption(position, value);
      });
    });

    function selectOption(position, value) {
      state.options[position] = value;

      // Buscar variante que coincida con la selección actual.
      // Recorremos todas las opciones del producto (1-indexed).
      const matchedVariant = productData.variants.find(v => {
        return productData.options.every((_, idx) => {
          const pos = idx + 1;
          return v[`option${pos}`] === state.options[pos];
        });
      });

      if (matchedVariant) {
        state.variant = matchedVariant;
        updateUI();
      }
    }

    function updateUI() {
      const variant = state.variant;
      if (!variant) return;

      // Actualizar input de variante
      const variantInput = section.querySelector('[data-variant-id-input]');
      if (variantInput) variantInput.value = variant.id;

      // Actualizar URL sin recargar (?variant=)
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      // Actualizar precio
      const priceEl = section.querySelector('[data-price]');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      // Actualizar precio comparado (sale)
      const comparePriceEl = section.querySelector('[data-compare-price]');
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      // Actualizar cuotas
      const installmentsEl = section.querySelector('.pdp-gc__installments');
      if (installmentsEl) {
        const installment = Math.round(variant.price / 3);
        installmentsEl.innerHTML = 'o <strong>3 cuotas sin interés</strong> de ' + formatMoney(installment);
      }

      // Actualizar etiqueta seleccionada (Color: Ecru, Talla: S)
      productData.options.forEach((option, idx) => {
        const optionName = (typeof option === 'string' ? option : option.name).toLowerCase();
        const selectedEl = section.querySelector(`[data-option-name="${optionName}"]`);
        if (selectedEl) {
          selectedEl.textContent = '— ' + state.options[idx + 1];
        }
      });

      // Actualizar stock alert
      const stockAlert = section.querySelector('[data-stock-alert]');
      const stockMsg = section.querySelector('[data-stock-message]');
      if (variant.inventory_quantity !== undefined && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
        if (stockMsg) stockMsg.textContent = `Quedan solo ${variant.inventory_quantity} unidades en esta talla`;
        if (stockAlert) stockAlert.style.display = '';
      } else {
        if (stockAlert) stockAlert.style.display = 'none';
      }

      // Actualizar botón add to cart
      const addBtn = section.querySelector('[data-add-to-cart]');
      const addText = section.querySelector('[data-add-text]');
      if (addBtn && addText) {
        if (variant.available) {
          addBtn.disabled = false;
          addText.textContent = 'Agregar al carrito';
        } else {
          addBtn.disabled = true;
          addText.textContent = 'Sin stock';
        }
      }

      // Actualizar imagen principal si la variante tiene featured_image distinta
      if (variant.featured_image && variant.featured_image.position) {
        showSlide(variant.featured_image.position - 1);
      }

      // Actualizar sticky cart
      updateStickyCart();
    }

    function formatMoney(cents) {
      // Formato chileno: $34.900
      const amount = Math.round(cents / 100);
      return '$' + amount.toLocaleString('es-CL');
    }

    // ============== STICKY CART ==============
    const stickyCart = document.querySelector('[data-sticky-cart]');
    const mainAddBtn = section.querySelector('[data-add-to-cart]');

    function updateStickyCart() {
      if (!stickyCart) return;
      const variant = state.variant;
      if (!variant) return;

      // Foto
      const photo = stickyCart.querySelector('[data-sticky-image]');
      if (photo && variant.featured_image) {
        photo.src = variant.featured_image.src ?
          variant.featured_image.src.replace(/_(small|medium|large|grande)\./, '_small.') :
          (productData.featured_image || '');
      } else if (photo && productData.featured_image) {
        photo.src = productData.featured_image;
      }

      // Precio
      const price = stickyCart.querySelector('[data-sticky-price]');
      if (price) price.textContent = formatMoney(variant.price);

      // Variante (talla · color)
      const variantText = stickyCart.querySelector('[data-sticky-variant]');
      if (variantText) {
        // state.options es 1-indexed; iteramos por las opciones reales del producto
        const parts = productData.options.map((_, idx) => state.options[idx + 1]).filter(Boolean);
        variantText.textContent = parts.join(' · ');
      }

      // Botón
      const btn = stickyCart.querySelector('[data-sticky-btn]');
      if (btn) {
        if (variant.available) {
          btn.disabled = false;
          btn.textContent = 'Agregar';
        } else {
          btn.disabled = true;
          btn.textContent = 'Sin stock';
        }
      }
    }

    function showSticky() {
      if (!stickyCart || !mainAddBtn) return;
      const rect = mainAddBtn.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyCart.classList.add('is-visible');
      } else {
        stickyCart.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', showSticky, { passive: true });
    showSticky();
    updateStickyCart();

    // ============== ADD TO CART AJAX ==============
    const form = section.querySelector('[data-product-form]');
    const stickyBtn = stickyCart ? stickyCart.querySelector('[data-sticky-btn]') : null;

    if (form) {
      // useCapture=true para correr antes que cualquier listener del tema base.
      // stopImmediatePropagation dentro del handler bloquea cualquier otro listener
      // que pudiera estar enganchado al mismo form y disparando un segundo cart/add.
      form.addEventListener('submit', handleSubmit, true);
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        handleSubmit(e);
      });
    }

    function handleSubmit(e) {
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      // Bloquear cualquier otro listener del tema base que también esté
      // enganchado al form y pueda disparar un segundo cart/add.
      if (e && typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      if (e && typeof e.stopPropagation === 'function') e.stopPropagation();

      // Guard contra dobles disparos (sticky + main, o doble click rápido)
      if (state.isSubmitting) return;

      const variant = state.variant;
      if (!variant || !variant.available) return;

      state.isSubmitting = true;

      const submitBtn = form.querySelector('[data-add-to-cart]');
      const submitText = form.querySelector('[data-add-text]');
      const originalText = submitText ? submitText.textContent : '';

      // Deshabilitar de inmediato (antes del fetch) para bloquear clicks repetidos
      if (submitBtn) submitBtn.disabled = true;
      if (stickyBtn) stickyBtn.disabled = true;
      if (submitText) submitText.textContent = 'Agregando…';
      if (stickyBtn) stickyBtn.textContent = 'Agregando…';

      const formData = new FormData(form);

      // Pedir en la MISMA request las secciones que el drawer necesita repintar.
      // Sin esto, /cart/add.js devuelve solo el item y el drawer queda con el HTML
      // que se renderizó al cargar la página (o sea, vacío o desactualizado).
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        formData.append('sections', cartDrawer.getSectionsToRender().map(s => s.id));
        formData.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(r => r.json())
        .then(data => {
          if (data.status) {
            // Error
            if (submitText) submitText.textContent = originalText;
            if (submitBtn) submitBtn.disabled = false;
            if (stickyBtn) {
              stickyBtn.disabled = false;
              stickyBtn.textContent = 'Agregar';
            }
            alert(data.description || data.message || 'Error al agregar al carrito');
            state.isSubmitting = false;
            return;
          }

          // Éxito · feedback visual
          if (submitText) submitText.textContent = '✓ Agregada al carrito';
          if (stickyBtn) stickyBtn.textContent = '✓ Agregada';

          // Disparar evento global para que el ícono del carrito en el header se actualice
          document.dispatchEvent(new CustomEvent('cart:updated'));

          // Repintar el drawer con el carrito actualizado y abrirlo.
          // renderContents() inyecta las secciones que pedimos arriba y llama a open()
          // internamente, por eso no hay que abrirlo por separado.
          let drawerRendered = false;
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
            try {
              if (typeof cartDrawer.setActiveElement === 'function') {
                cartDrawer.setActiveElement(submitBtn || document.activeElement);
              }

              // El <cart-drawer> se renderiza con la clase is-empty cuando la página
              // cargó con el carrito vacío, y renderContents() NO la limpia (solo toca
              // .drawer__inner). Ese nodo es el único que no se reemplaza al inyectar
              // las secciones, así que la clase queda pegada y el CSS de Dawn oculta el
              // encabezado y los ítems. Como acabamos de agregar algo, el carrito no
              // está vacío: la sacamos antes de repintar.
              cartDrawer.classList.remove('is-empty');

              cartDrawer.renderContents(data);
              drawerRendered = true;
            } catch(e) {
              console.error('PDP: error al repintar el drawer', e);
            }
          }

          // Fallback: si no hay drawer o no vinieron las secciones, al menos abrirlo
          if (!drawerRendered && cartDrawer && typeof cartDrawer.open === 'function') {
            try { cartDrawer.open(); } catch(e) { /* no-op */ }
          }

          // Restaurar botón después de 2 segundos
          setTimeout(() => {
            if (submitText) submitText.textContent = originalText;
            if (submitBtn) submitBtn.disabled = false;
            if (stickyBtn) {
              stickyBtn.disabled = false;
              stickyBtn.textContent = 'Agregar';
            }
            state.isSubmitting = false;
          }, 2000);

          // Actualizar el contador del header solo si el drawer NO se repintó.
          // Si renderContents() corrió, ya trae el cart-icon-bubble al día y escribir
          // acá encima rompería su markup interno.
          if (!drawerRendered) {
            fetch('/cart.js')
              .then(r => r.json())
              .then(cart => {
                const cartCount = document.querySelector('[data-cart-count], .cart-count-bubble');
                if (cartCount) cartCount.textContent = cart.item_count;
              })
              .catch(() => {});
          }
        })
        .catch(err => {
          console.error('Cart add error:', err);
          if (submitText) submitText.textContent = originalText;
          if (submitBtn) submitBtn.disabled = false;
          if (stickyBtn) {
            stickyBtn.disabled = false;
            stickyBtn.textContent = 'Agregar';
          }
          alert('Hubo un problema. Intenta nuevamente.');
          state.isSubmitting = false;
        });
    }
  }
})();